@if (config().visible) {
  <div class="row" [formGroup]="formGroup">
    <mat-form-field>
      <mat-label>{{ config().i18nKey() | ppLabel: config().label }}</mat-label>
      <mat-select formControlName="{{ config().attrName }}">
        @for (option of config().getSelectables(); track option.value) {
          <mat-option [value]="option.value">{{ option.value }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
